'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { motion, type Variants } from 'motion/react';
import { getVariants, useAnimateIconContext, IconWrapper, type IconProps } from '@/components/animate-ui/icons/icon';
type ChartLineProps = IconProps<keyof typeof animations>;
const animations = {
  default: {
    path1: {},
    path2: {
      initial: {
        opacity: 1,
        pathLength: 1,
        pathOffset: 0
      },
      animate: {
        opacity: [0, 1],
        pathLength: [0, 1],
        pathOffset: [1, 0],
        transition: {
          duration: 0.8,
          ease: 'easeInOut',
          opacity: {
            duration: 0.01
          }
        }
      }
    }
  } satisfies Record<string, Variants>,
  'default-loop': {
    path1: {},
    path2: {
      initial: {
        opacity: 1,
        pathLength: 1,
        pathOffset: 0
      },
      animate: {
        opacity: [1, 0, 1],
        pathLength: [1, 0, 1],
        pathOffset: [0, 1, 0],
        transition: {
          duration: 1.6,
          ease: 'easeInOut',
          opacity: {
            duration: 0.01
          }
        }
      }
    }
  } satisfies Record<string, Variants>
} as const;
function IconComponent(t0) {
  const $ = _c(12);
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = size;
  } else {
    props = $[1];
    size = $[2];
  }
  const {
    controls
  } = useAnimateIconContext();
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getVariants(animations);
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const variants = t1;
  let t2;
  let t3;
  if ($[4] !== controls) {
    t2 = <motion.path d="M3 3v16a2 2 0 0 0 2 2h16" variants={variants.path1} initial="initial" animate={controls} />;
    t3 = <motion.path d="m19 9-5 5-4-4-3 3" variants={variants.path2} initial="initial" animate={controls} />;
    $[4] = controls;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props || $[8] !== size || $[9] !== t2 || $[10] !== t3) {
    t4 = <motion.svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" {...props}>{t2}{t3}</motion.svg>;
    $[7] = props;
    $[8] = size;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function ChartLine(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <IconWrapper icon={IconComponent} {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export { animations, ChartLine, ChartLine as ChartLineIcon, type ChartLineProps, type ChartLineProps as ChartLineIconProps };